import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { Link } from "react-router-dom";

class CounterpartyPoints extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) => <Link to={paths.counterpartyPointShow(this.props.match.params.counterpartyId, id)}>{value}</Link>,
            },
            {
                Header: "Клиент",
                accessor: "client",
                filterable: true,
            },
            {
                Header: "Адрес",
                accessor: "geozone",
                id: "geozone/address",
                filterable: true,
                sortKey: "geozone/address",
                Cell: ({ value }) => value.address,
            },
            {
                Header: "Дата последнего использования",
                accessor: "lastUsedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
        ];
    }

    renderCreateButton = () => {
        const { match } = this.props;
        const props = {
            className: "btn btn-brand btn-sm",
            to: paths.counterpartyPointsNew(match.params.counterpartyId),
        };
        return <Link {...props}>Добавить новый адрес</Link>;
    };

    render() {
        const { getList, ...props } = this.props;
        return (
            <div className="container-fluid h-100 pb-3">
                <div className="card card-body h-100">
                    <div className="d-flex flex-column h-100">
                        <div className="d-flex justify-content-end pb-3">{this.renderCreateButton()}</div>
                        <div className="flex-grow-1 overflow-hidden">
                            <SharedReactTable
                                {...props}
                                source={{
                                    ...props.source,
                                    getListExcel: (params) =>
                                        props.source.getListExcel({
                                            ...params,
                                            counterpartyId: parseInt(props.match.params.counterpartyId),
                                        }),
                                }}
                                wrapCname="h-100"
                                getList={(params) =>
                                    getList({ ...params, counterpartyId: parseInt(props.match.params.counterpartyId) })
                                }
                                columns={this.state.tableColumns}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default tableContainer(CounterpartyPoints, "counterpartypoints");
